export default __webpack_public_path__ + "static/media/stick-no-bg.f69c1b3f.svg";